import { Guid } from 'Lib/Guid';
import { IApiDataModel } from './IApiDataModel';

export type SyncConflictUser = {
  Name: string;
  Timestamp: string;
};

export interface IDataSyncModel {
  id: Guid;
  data: IApiDataModel;
  header: any | null;
  type: any | null;
  syncVersionData: object | null; // null implies skip conflict resolution, see QESTNet implementation
  hasSyncConflict: boolean;
  syncConflictUsers?: SyncConflictUser[];
}

export const isIDataSyncModel = (arg: any): arg is IDataSyncModel => arg && arg.id && arg.data && arg.syncVersionData;
